import { Component } from '@mna/react'
import { GoogleMap, Marker } from 'react-google-maps'
import { MAP } from 'react-google-maps/lib/constants'
import {
  defaultZoom,
  defaultCenter,
  createMapWithDefaults,
  mapOptions,
  markerIconOptions} from './mapCommon'

class Map extends Component {

  els = {}

  constructor(props) {

    super(props)

    const {
      zoom,
      center,
      currentLocation,
      markers = []
    } = this.props

    this.state = {
      bounds: null,
      zoom: zoom || defaultZoom,
      center: center || currentLocation || defaultCenter,
      markers,
      currentLocation,
      currentLatAndLng : {
        lat: 0, lng: 0
      }
    }

  }

  componentWillUpdate() {
  }

  onMapMounted = ref => {

    const map = this.els.map = ref
    if (!map) return

    const { google } = window
    if (!google) return

    if (this.props.onMapMounted) {
      this.props.onMapMounted({
        google,
        map: map.context[MAP], // Actual map instance
        reactGoogleMap: map
      })
    }

    const { markers } = this.state
    const markerLength = markers && markers.length
    if (!markerLength) return

    // Fit all markers on map

    const bounds = new google.maps.LatLngBounds()
    for (var i = 0; i < markers.length; i++) {
      bounds.extend(markers[i]) // .getPosition()
    }

    // Don't zoom in too far on only one marker

    if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
      const extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01)
      const extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01)
      bounds.extend(extendPoint1)
      bounds.extend(extendPoint2)
    }

    map.fitBounds(bounds, 100) //  Offset
  }

  onBoundsChanged = () => {

    const boundsData = {
      bounds: this.els.map.getBounds(),
    }

    this.setState(boundsData)
  }

  render() {

    const { google } = window
    if (!google) return null

    const {
      header,
      children = [],
      onMarkerClick    } = this.props

    const { markers = [] } = this.state
    const currentLocation = this.state.currentLocation
      || this.props.currentLocation
      
    this.state.currentLatAndLng.lat = parseFloat(window.sessionStorage.getItem("lat"));
    this.state.currentLatAndLng.lng = parseFloat(window.sessionStorage.getItem("lng"));
      

    if (markers && markers.length && !children.length) {

        
  const CurrentMarker = (<Marker position={this.state.currentLatAndLng} 
    icon={{url:'https://maps.google.com/mapfiles/kml/paddle/grn-circle.png',
     scaledSize: new google.maps.Size(25, 25)}}  title="You are here"  />)
     children.push(CurrentMarker)
  
      const Markers = markers
        .map((marker, markerIndex) =>
          // Validate to ensure Google Maps renders
          (marker.lat===undefined || marker.lng===undefined) ? null
            :
            <Marker key={`marker-${markerIndex}`}
              position={marker}
              title={`marker-${markerIndex}`}
              icon={markerIconOptions}

              // Styled marker
              //optimized={false} icon={styledMarkerPlaceholderUrl}

              onClick={() => {
                //console.log('Marker clicked', markerIndex)
                if (onMarkerClick) onMarkerClick({ index: markerIndex })
              }}
            />
        )
        .filter(m => m ? true : false)

      children.push(...Markers)
    }

    return (
      <GoogleMap
        ref={this.onMapMounted}
        zoom={this.state.zoom || defaultZoom}
        center={currentLocation || this.state.center}
        onBoundsChanged={this.onBoundsChanged}
        options={mapOptions}
      >
        <div className="absolute top left w-100" >
          { header }
        </div>
        { children }
      </GoogleMap>
    )
  }
}

export default createMapWithDefaults(Map)
